<template>
    <div>
        <multiselect
            :placeholder="$t('select')"
            v-model="selected"
            :options="options"
            :class="validateError != '' ? 'box-border-color':''"
            @input="handleInput($event)"
            label="text"
            track-by="value"
            :multiple="false"
            :select-label="''"
            :selected-label="''"
            :deselect-label="''"
            :searchable="true">
            <span slot="noOptions">
                {{ $t('no_options') }}
            </span>
            <span slot="noResult">
                {{ $t('no_result') }}
            </span>
        </multiselect>
        <span class="invalid-feedback-custom"
              v-show="validateError"
              v-html="validateError"/>
    </div>
</template>

<script>
import setSelected from "@/helpers/setSelected";
import handleInput from "@/helpers/handleInput";

import qs from "qs";
import SectionService from "@/services/SectionService";

export default {
    props: {
        semester_id: {
            type: Number,
            default: null
        },
        academic_year: {
            type: String,
            default: null
        },
        course_code: {
            type: String,
            default: null
        },
        value: {
            default: null
        },
        valueType: {
            type: String,
            default: 'section'
        },
        validateError: {
            type: String,
            default: ''
        },
    },
    watch: {
        value: function (newValue) {
            this.selected = this.setSelected(newValue, this.options);
        },
        semester_id: function () {
            this.getOptions()
        },
        academic_year: function () {
            this.getOptions()
        },
        course_code: function () {
            this.getOptions()
        },
    },
    created() {
        this.getOptions();
    },
    data() {
        return {
            selected: null,
            options: [],
        }
    },
    methods: {
        setSelected: setSelected,
        handleInput: handleInput,
        getOptions() {
            this.options = [];

            if(this.semester_id && this.academic_year && this.course_code) {
                const config = {
                    params: {
                        filter: {
                            semester_id: this.semester_id,
                            course_code: this.course_code,
                            academic_year: this.academic_year,
                        },
                        limit: -1
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                }
                SectionService.options(config)
                    .then(response => {
                        const data = response.data.data;
                        data.forEach((item) => {
                            this.options.push({
                                value: item.section,
                                text: item.section,
                            });
                        });
                    })
                    .then(() => {
                        this.selected = this.setSelected(this.value, this.options);
                        if (this.selected == null || this.selected.length == 0) {
                            this.$emit("input", null)
                        }
                    })
            }
        }
    }
}
</script>
